import React from 'react';
import { Modal } from "antd";
import PricingPlansCards from "./_PricingPlansCards";

interface PricingPlansModalProps {
  uid: string | null;
  number: string;
  onClose: () => void;
}

const _PricingPlansModal = ({ uid, number, onClose }: PricingPlansModalProps) => (
  <Modal
    title={`Subscription Plans — ${number}`}
    open={!!uid}
    onCancel={onClose}
    footer={null}
    width={700}
    destroyOnClose
  >
    {uid && <PricingPlansCards uid={uid} />}
  </Modal>
);

export default _PricingPlansModal;
